<template>
    <div class="yy">
      <!-- 上盒子 -->
      <div class="yy-box1">
          <!-- <div class="yy-box1-1">走进翼博</div> -->
          <ul>
              <li><router-link to="/honor/myzs1">企业简介</router-link></li>
              <li><router-link to="/honor/myzs2">企业文化</router-link></li>
              <li><router-link to="/honor/myzs3">组织架构</router-link></li>
              <li><router-link to="/honor/myzs4">企业资质</router-link></li>
              <li><router-link to="/honor/myzs7">企业体系认证</router-link></li>
              <li><router-link to="/honor/myzs8">企业信用认证</router-link></li>
              <li><router-link to="/honor/myzs5">荣誉证书</router-link></li>
              <li><router-link to="/honor/myzs6">新闻动态</router-link></li>
          </ul>
      </div>
  
      <!-- 下盒子 -->
      <div class="ryzs">
        <!-- <img :src="item" alt="" v-for="(item,index) in image1" :key="index"> -->
        <img src="https://ybcy1.oss-cn-chengdu.aliyuncs.com/emp/2026-05-14-15-52-07-40315%E3%80%81%E6%81%92%E8%BE%BE%E6%99%BA%E6%8E%A7%E4%BC%98%E7%A7%80%E5%9B%A2%E9%98%9F2026.jpg" alt="">
        <img src="https://ybcy1.oss-cn-chengdu.aliyuncs.com/emp/2026-05-14-15-52-24-99514%E3%80%81%E4%B8%AD%E6%9C%BA%E5%85%AD%E9%99%A2%E5%8C%A0%E5%BF%83%E9%A4%90%E9%A5%AE%E5%90%88%E4%BD%9C%E4%BC%99%E4%BC%B42026.jpg" alt="">
        <img src="https://ybcy1.oss-cn-chengdu.aliyuncs.com/emp/2026-05-14-15-52-34-16613%E3%80%81%E5%93%88%E5%BC%97%E8%81%94%E7%9B%9F%E4%B8%9C%E6%B0%B4%E5%AF%A8%E6%9D%91%E5%85%AC%E7%9B%8A%E6%B4%BB%E5%8A%A8%E8%8D%A3%E8%AA%89%E8%AF%81%E4%B9%A6.jpg" alt="">
        <img src="https://ybcy1.oss-cn-chengdu.aliyuncs.com/emp/2026-05-14-15-53-40-02612%E3%80%81%E4%B8%9C%E6%B0%B4%E5%AF%A8%E6%9D%91%E5%85%AC%E7%9B%8A%E6%B4%BB%E5%8A%A8%E8%8D%A3%E8%AA%89%E8%AF%81%E4%B9%A6.jpg" alt="">
        <img src="https://ybcy1.oss-cn-chengdu.aliyuncs.com/emp/2026-05-14-15-53-58-20411%E3%80%81%E9%A4%90%E9%A5%AE%E5%8D%81%E4%BD%B3%E8%81%8C%E4%B8%9A%E7%BB%8F%E7%90%86%E4%BA%BA-%E6%9D%A8%E5%A4%A9%E9%BE%99.jpg" alt="">
        <img src="https://ybcy1.oss-cn-chengdu.aliyuncs.com/emp/2026-05-14-15-54-07-88810%E3%80%81%E5%8D%81%E4%BD%B3%E9%A4%90%E9%A5%AE%E4%BC%81%E4%B8%9A.jpg" alt="">
        <img src="https://ybcy1.oss-cn-chengdu.aliyuncs.com/emp/2026-05-14-15-54-18-8368%E3%80%81%E4%B8%83%E4%B8%80%E4%B8%89%E6%89%80%E4%BC%98%E8%B4%A8%E5%90%88%E4%BD%9C%E4%BC%99%E4%BC%B4.jpg" alt="">
        <img src="https://ybcy1.oss-cn-chengdu.aliyuncs.com/emp/2026-05-14-15-54-29-7817%E3%80%81%E6%B2%B3%E5%8D%97%E7%9C%81%E7%96%AB%E6%83%85%E9%98%B2%E6%8E%A7%E5%85%88%E8%BF%9B%E5%8D%95%E4%BD%8D.jpg" alt="">
        <img src="https://ybcy1.oss-cn-chengdu.aliyuncs.com/emp/2026-05-14-15-55-02-2156%E3%80%81%E5%85%A8%E5%9B%BD%E9%AB%98%E6%A0%A1%E5%90%8E%E5%8B%A4%E4%BC%98%E7%A7%80%E6%9C%8D%E5%8A%A1%E4%BC%81%E4%B8%9A.jpg" alt="">
        <img src="https://ybcy1.oss-cn-chengdu.aliyuncs.com/emp/2026-05-14-15-55-19-0814%E3%80%81%E5%85%A8%E5%9B%BD%E4%BC%98%E7%A7%80%E9%A4%90%E9%A5%AE%E4%BC%81%E4%B8%9A.jpg" alt="">
        
          
      </div>
    </div>
  </template>

<script>
export default {
  data(){
    return {
      image1: []
    };
  },
  created(){
    //this.getApatitude();
  },
  methods: {
    //接口需要token，官网不需要登陆，无token，认证失败
    getApatitude(){
            axios.get("https://yibocanyin.com:9001/api/zbAptitude/page",{params:{pageNum:1,pageSize:15,type:'荣誉证书'}})
        .then(res => { 
          if (res.code === 200) {
          this.image1 = res.data.records.map(item=>item.img)
        } })
        .catch(err => console.error("获取失败", err));  
    }
  }
}
</script>

<style scoped>
*{
    box-sizing: border-box;
}
.ryzs {
  width: 60%;
  margin: 0 auto;
}
.sizeSty {
  width: 40%;
}
</style>